import { Component, Input, OnInit } from '@angular/core';
import { FinanceService } from '../../services/finance.services';

@Component({
    selector: 'investment-graphic',
    templateUrl: 'investment-graphic.component.html',
    styleUrls: ['investment-graphic.component.scss'],
})

export class InvestmentGraphicComponent implements OnInit {

    @Input('initialValue') public initialValue: number;
    @Input('monthlyValue') public monthlyValue: number;
    @Input() public profile: number;

    public animated = false;
    public finalYear: number;
    public calculatedValue: number;

    constructor(
        private financeService: FinanceService,
    ) {

        this.finalYear = (new Date()).getFullYear() + 10;

        setTimeout(() => {
            this.animated = true;
        }, 1000);
    }

    public ngOnInit() {
        let tax = '';

        if (this.profile === 2) tax = '115';
        else if (this.profile === 3) tax = '141';
        else if (this.profile === 4) tax = '157';

        this.calculatedValue = this.financeService.calculateTax(this.initialValue, tax, 120, 'CDI', 7, this.monthlyValue);
    }
}
